import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, RadioGroup, RadioCard} from 'views/components';

import {Translate, translate} from 'views/module';

const SelectEventType = (props) => {
  const eventType = props.eventType || '';
  const setEventType = props.setEventType;
  const setIsStepValid = props.setIsStepValid;
  const handleNext = props.handleNext;

  const updateEventType = (e) => {
    setEventType(e);
    if (!eventType) {
      handleNext();
    }
  };

  React.useEffect(() => {
    setIsStepValid(eventType);
  }, [eventType]);

  return (
    <Grid container spacing={1}>
      <Grid item md={12} xs={12}>
        <RadioGroup
          value={eventType}
          onChange={updateEventType}
          label=''
        >
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <RadioCard
                label={translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.FixedEventTitle')}
                value={'FIXED_EVENT'}
                selected={eventType === 'FIXED_EVENT'}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.FixedEventExplain'/>
              </RadioCard>
            </Grid>
            <Grid item xs={6}>
              <RadioCard
                label={translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.RecurringEventTitle')}
                value={'RECURRENCE_EVENT'}
                selected={eventType === 'RECURRENCE_EVENT'}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.RecurringEventExplain'/>
              </RadioCard>
            </Grid>
            <Grid item xs={6}>
              <RadioCard
                label={translate('client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.LiveInEventTitle')}
                value={'LIVEIN_EVENT'}
                selected={eventType === 'LIVEIN_EVENT'}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.SelectEventType.LiveInEventExplain'/>
              </RadioCard>
            </Grid>
          </Grid>
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

SelectEventType.propTypes = {
  eventType: PropTypes.oneOf(['RECURRENCE_EVENT', 'FIXED_EVENT']),
  setEventType: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(SelectEventType));
